import "core-js/modules/es.array.join.js";
import React from 'react';
import { Box } from '@applyboard/ui-components';
import Content from "../Content";
import TabSelector from "../TabSelector";
import { usePageSettings } from "../PageSettings";
import displayLoadingState from "../../../components/LoadingPage/displayLoadingState";
import { ApplicationContainer, RightContent } from "./styles";
import { RequirementFeedbackButton } from "../RequirementFeedbackButton";
import { PendingPaymentNotification } from "../PendingPaymentNotification";
import useDispatch from "../../../hooks/useDispatch";
import { loadBaseApplication } from "../enhancer";
import { getApplicationRequirementsAction } from "../../../api/jsonapi";
var loadingEnhancer = displayLoadingState();
var ApplicationDisplay = function ApplicationDisplay(_ref) {
  var _application$school, _application$school2, _application$program, _application$program2;
  var permissions = _ref.permissions,
    application = _ref.application,
    searchParameters = _ref.searchParameters,
    selectedTab = _ref.selectedTab,
    sidebar = _ref.sidebar,
    applicationStepper = _ref.applicationStepper,
    RemoveFileDialog = _ref.RemoveFileDialog,
    DocumentVerificationModal = _ref.DocumentVerificationModal,
    VerificationResults = _ref.VerificationResults,
    onSidebarOpenChange = _ref.onSidebarOpenChange,
    reloadAggregatedData = _ref.reloadAggregatedData,
    RPSelfEvaluation = _ref.RPSelfEvaluation,
    RecommendedProgramsDialogLoader = _ref.RecommendedProgramsDialogLoader,
    HybridRequirementDecisionReasons = _ref.HybridRequirementDecisionReasons,
    HybridRequirementDialogButton = _ref.HybridRequirementDialogButton,
    HybridRequirementPreviewMode = _ref.HybridRequirementPreviewMode,
    isRequirementEvaluationPending = _ref.isRequirementEvaluationPending,
    aggregatedDataRequirements = _ref.aggregatedDataRequirements,
    ApplicantRequirementList = _ref.ApplicantRequirementList,
    AdminRequirementList = _ref.AdminRequirementList,
    renderNotesList = _ref.renderNotesList,
    hideApplicationRequirementsHeader = _ref.hideApplicationRequirementsHeader,
    hideAdminRequirementsHeader = _ref.hideAdminRequirementsHeader,
    canCreateBulkNote = _ref.canCreateBulkNote,
    commissionTab = _ref.commissionTab;
  var _usePageSettings = usePageSettings(),
    appName = _usePageSettings.appName;
  var dispatch = useDispatch();
  var showRequirementsFeedbackButton = (permissions === null || permissions === void 0 ? void 0 : permissions.provide_requirement_feedback) && selectedTab.toLowerCase() !== 'preview requirements' && appName !== 'admin';
  return /*#__PURE__*/React.createElement(ApplicationContainer, null, sidebar, /*#__PURE__*/React.createElement(RightContent, null, RPSelfEvaluation && application && /*#__PURE__*/React.createElement(RPSelfEvaluation, {
    onSuccess: function onSuccess() {
      loadBaseApplication(application === null || application === void 0 ? void 0 : application.id, dispatch);
      dispatch(getApplicationRequirementsAction({
        include: ['application_additional_attachments', 'application_external_links', 'attachments', 'application_questions'].join(','),
        application_id: application === null || application === void 0 ? void 0 : application.id
      }));
    }
  }), /*#__PURE__*/React.createElement(PendingPaymentNotification, {
    application: application
  }), /*#__PURE__*/React.createElement(TabSelector, {
    permissions: permissions,
    onSidebarOpenChange: onSidebarOpenChange,
    reloadAggregatedData: reloadAggregatedData,
    showPreviewButton: !ApplicantRequirementList,
    hideApplicationRequirementsHeader: hideApplicationRequirementsHeader,
    hideAdminRequirementsHeader: hideAdminRequirementsHeader,
    showNewAdminRequirementTab: !!AdminRequirementList,
    canCreateBulkNote: canCreateBulkNote,
    showCommissionTab: !!commissionTab
  }), /*#__PURE__*/React.createElement(Content, {
    searchParameters: searchParameters,
    permissions: permissions,
    DocumentVerificationModal: DocumentVerificationModal,
    VerificationResults: VerificationResults,
    reloadAggregatedData: reloadAggregatedData,
    RemoveFileDialog: RemoveFileDialog,
    HybridRequirementDecisionReasons: HybridRequirementDecisionReasons,
    HybridRequirementDialogButton: HybridRequirementDialogButton,
    HybridRequirementPreviewMode: HybridRequirementPreviewMode,
    isRequirementEvaluationPending: isRequirementEvaluationPending,
    aggregatedDataRequirements: aggregatedDataRequirements,
    ApplicantRequirementList: ApplicantRequirementList,
    AdminRequirementList: AdminRequirementList,
    renderNotesList: renderNotesList,
    commissionTab: commissionTab
  }), /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    pr: 2.5,
    pt: 1
  }, showRequirementsFeedbackButton && /*#__PURE__*/React.createElement(RequirementFeedbackButton, {
    position: "bottom",
    application: application
  }))), /*#__PURE__*/React.createElement(RecommendedProgramsDialogLoader, {
    school: {
      id: application === null || application === void 0 ? void 0 : (_application$school = application.school) === null || _application$school === void 0 ? void 0 : _application$school.id,
      country: application === null || application === void 0 ? void 0 : (_application$school2 = application.school) === null || _application$school2 === void 0 ? void 0 : _application$school2.country_code
    },
    program: {
      id: application === null || application === void 0 ? void 0 : (_application$program = application.program) === null || _application$program === void 0 ? void 0 : _application$program.id,
      level: application === null || application === void 0 ? void 0 : (_application$program2 = application.program) === null || _application$program2 === void 0 ? void 0 : _application$program2.level_text
    },
    academicIntake: application === null || application === void 0 ? void 0 : application.intake,
    eslIntake: application === null || application === void 0 ? void 0 : application.intake_esl
  }), applicationStepper);
};
export default loadingEnhancer(ApplicationDisplay);